import { Button, Typography } from '@mui/material';
import type { BackupPolicyType, BackupSchedule } from '@repo/api-gw-sdk';
import { forwardRef } from 'react';

import { OptionMenu } from '@/components/option-menu/option-menu';

import { useFrequencyOptions } from './useFrequencyOptions';

import { getFrequencyByWindow, getWindowHoursDuration } from '../frequency';

export const FrequencyWindowSelector = (props: {
  schedule: BackupSchedule;
  onUpdate: (schedule: BackupSchedule) => void;
  policyType: BackupPolicyType;
}) => {
  const updateWindow = (window: string) => {
    const frequency = getFrequencyByWindow(window);
    if (!frequency) {
      return;
    }

    props.onUpdate({
      ...props.schedule,
      windows: frequency.windows,
      backupRetention: frequency.defaultRetentionInDays,
      duration: getWindowHoursDuration(frequency) * 60,
    });
  };

  const frequency = getFrequencyByWindow(props.schedule.windows);

  const options = useFrequencyOptions(
    frequency,
    props.policyType,
    props.schedule
  );

  return (
    <OptionMenu
      placement='bottom-start'
      onOptionSelected={(option) => {
        if (typeof option !== 'string') {
          updateWindow(option.id || '');
        }
      }}
      options={options}
      Component={TriggerButton}
      componentProps={{ buttonText: frequency?.text.toLowerCase() }}
    />
  );
};

const TriggerButton = forwardRef<HTMLButtonElement, { buttonText: string }>(
  (props, ref) => {
    const { buttonText, ...rest } = props;

    return (
      <Button
        sx={{
          padding: '5px 12px',
        }}
        data-testid='create-backup-policy-frequency-select'
        disableFocusRipple
        ref={ref}
        {...rest}
      >
        <Typography fontWeight={600}>{buttonText}</Typography>
        <i className='material-symbols-arrow-drop-down-rounded text-[22px] ml-[4px]' />
      </Button>
    );
  }
);
